import React from "react";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";
import Switch, { SwitchProps } from "@material-ui/core/Switch";

import useStyles from "./styles";

interface IProps extends SwitchProps {
  title: string;
  onSwitchToggle: () => void;
  className?: string;
}

const Toggle = (props: IProps) => {
  const { title, onSwitchToggle, className, disabled, ...restProps } = props;

  const classes = useStyles();

  return (
    <div className={className}>
      <Grid component="label" container alignItems="center" spacing={1}>
        <Grid item className={clsx(classes.toggleTitle, { disabled })}>
          {title}
        </Grid>
        <Grid item>
          <Switch
            {...restProps}
            onChange={onSwitchToggle}
            disabled={disabled}
            classes={{
              root: classes.root,
              switchBase: classes.switchBase,
              thumb: classes.thumb,
              track: classes.track,
              checked: classes.checked
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default React.memo(Toggle);
